import React from 'react'

function Menu(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 12"
            height={props.height}
            width={props.width}
        >
            <path
                fill={props.colorOne}
                d="M17 12a1 1 0 001-1 1 1 0 00-1-1H1a1 1 0 00-1 1 1 1 0 001 1h16zm0-5a1 1 0 001-1 1 1 0 00-1-1H1a1 1 0 00-1 1 1 1 0 001 1h16zM0 1a1 1 0 001 1h16a1 1 0 001-1 1 1 0 00-1-1H1a1 1 0 00-1 1z"
            />
        </svg>
    )
}

export default Menu
